import React from 'react';
import {FaCalendar, FaCamera, FaCarSide, FaClock} from "react-icons/fa";
import DivisorItem from "./divisor-item.jsx";
import projectUtils from "../../../../../../../utils/project-utils.js";
import {FaArrowUp19} from "react-icons/fa6";

const CoincidentPassagesDetails = ({data}) => {
    const formatThreshold = (threshold) => {
        const totalSeconds = Math.floor(threshold / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    }

    return (
        <>
            <p className={`text-[16px] font-bold text-white p-2 bg-[#6A4D9F]  mb-0`}>
                Análise <b>{data.filter.plate}</b>
            </p>
            <div className={"p-2"}>
                <DivisorItem icon={<FaCalendar size={18}/>} text={"Data inicial"} value={projectUtils.formatDate(data.filter.startDate)}/>
                <DivisorItem icon={<FaCalendar size={18}/>} text={"Data final"} value={projectUtils.formatDate(data.filter.endDate)}/>
                <DivisorItem icon={<FaClock size={18}/>} text={"Minuto:segundo antes e depois das passagens"} value={formatThreshold(data.filter.threshold)}/>
                <DivisorItem icon={<FaArrowUp19 size={18}/>} text={"Número mínimo de coincidências"} value={data.filter.minMatches}/>
                <DivisorItem icon={<FaCamera size={18}/>} text={"Limite de passagens"} value={data.filter.maxPassages}/>
                <DivisorItem icon={<FaCarSide size={18}/>} text={"Total de passagens"} value={data.passages.length}/>
            </div>
        </>
    )
}

export default CoincidentPassagesDetails;